import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import WhatIsSection from './components/WhatIsSection';
import WhySection from './components/WhySection';
import FeaturesSection from './components/FeaturesSection';
import HowItWorks from './components/HowItWorks';
import CategoryGrid from './components/CategoryGrid';
import ArticlesSection from './components/ArticlesSection';
import SafetySection from './components/SafetySection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import { faqData } from '@/mocks/categories';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://vigorbuyspread.cam';

const homepageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Vigorbuy Spreadsheet 2026 | Complete Product Guide & Shopping Resource",
  "description": "Discover the latest Vigorbuy Spreadsheet 2026. Browse organized product categories, shopping guides, QC photo resources, safety tips, and expert recommendations.",
  "url": siteUrl + "/",
  "mainEntity": {
    "@type": "Organization",
    "name": "Vigorbuy Spreadsheet Hub",
    "url": siteUrl + "/",
    "description": "The most complete Vigorbuy Spreadsheet resource center for product discovery, shopping guides, and expert recommendations."
  }
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqData.map((faq) => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer,
    },
  })),
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homepageSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <WhatIsSection />
        <WhySection />
        <FeaturesSection />
        <HowItWorks />
        <CategoryGrid />
        <div id="articles" className="scroll-mt-20">
          <ArticlesSection />
        </div>
        <SafetySection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}